import * as React from 'react'

import Box from '@mui/material/Box'
import FormHelperText from '@mui/material/FormHelperText'
import { MultiSelect } from '@workwave-tidal/core/components'

import { useData, useHandlers } from './hooks'
import { TargetPestDataType } from './hooks/useData'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'

type Props = {
  required: boolean
  show: boolean
  name: string
  density: DensityType
  showCheckBox?: boolean
}

export function TargetPestSelect(props: Props) {
  const { required, show, name, density, showCheckBox } = props
  const {
    options,
    getOptionLabel,
    getId,
    initialOption,
    isSubmitting,
    showError,
    helperText,
  } = useData({ required, name })
  const { handelChange, handelBlur, handelFocus } = useHandlers()
  return show ? (
    <Box>
      <MultiSelect<TargetPestDataType>
        density={density}
        disabled={isSubmitting}
        required={required}
        getLabel={getOptionLabel}
        getId={getId}
        error={showError}
        items={options}
        onChange={handelChange}
        onFocus={handelFocus}
        onBlur={handelBlur}
        hideCheckbox={!showCheckBox}
        value={initialOption}
        label={'Target Pest(s)'}
        optionMode={'normal'}
        inputMode="normal"
        placeholder="Search Target Pest(s)"
        maxSelectedItemsToShow={4}
        maxSelectedItemsToShowOnFocus={4}
        testId="target-pest-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
